export const classes = {
  button:
    'place-center size-11 rounded-xl cursor-pointer select-none transition-colors',
  active: 'bg-grad text-white shadow-orange',
  activeCustom: 'text-white shadow-orange',
  inactive:
    'text-taupe-1 hover:bg-black/5 dark:text-mauve-3 dark:hover:bg-white/5',
  icon: 'place-center',
};

export const styles = {
  active: (color?: string, bgColor?: string) => ({
    color: color || 'white',
    backgroundColor: bgColor,
  }),
};

export function isActive(href: string, path: string) {
  const hrefParts = href.toLowerCase().split('/');
  const pathParts = path.toLowerCase().split('/');
  return hrefParts.every((part, i) => part === pathParts[i]);
}
